export default {
  // 導航
  app_nav: {
    businessManage: '系統管理',
    membersManage: '成員管理',
    roleManage: '角色管理',
    customApp: '自定義應用',
    safeManage: '安全管理',
    interfaceIntegratio: '接口集成',
    appCenter: '應用中心',
    recycleBin: '回收站',
    personalSetting: '個人設置',
    platformTemplate: '平臺模版',
    noAuth: '您沒有許可權訪問該模塊',
    accountCenter: '組織管理',
    applicationManagement: '應用管理',
    cloudDevelop: '雲開發',
    dataCenter: '數據中心',
    taskMonitoring: '自動化任務監控',
    systemTemplate: '系統模版'
  },
  // 企業管理
  business_management: {
    manageHomepage: '管理首頁',
    basicmodule: '基礎模塊',
    businessManage: '系統管理',
    businessSet: '企業設定',
    businessWorkflow: '企業工作流',
    welcome: '歡迎使用，您現在所在的是',
    managebackstage: '的管理後臺',
    currentVersion: '當前版本',
    versionInfo: '版本資訊',
    closingDate: '截止日期',
    systemVersion: '系統版本',
    accountUsage: '帳號使用情況',
    accountNum: '賬戶數',
    spaceUsage: '空間使用情況',
    space: '空間',
    dataUsage: '數據量使用情況',
    dataNum: '數據量',

    upgrade: '陞級',
    additional: '增購',
    remainingavailable: '剩餘可用',
    purchasedusersnumber: '已授權用戶數',
    usedusersnumber: '已使用用戶數',
    remainingdays: '剩餘天數',
    starttime: '開始時間',
    endtime: '結束時間',
    totaldataavailable: '可使用數據總量',
    totalamountdataused: '已使用數據總量',
    totalattachmentspace: '附件空間總數',
    attachmentspaceused: '已使用附件空間',
    cleardeletedfiles: '壹鍵清除已刪除檔',
    consumptionsituation: '消費情況',
    applyforinvoice: '申請開票',
    contractinformationperfect: '契約資訊完善',
    typeofbusiness: '業務類型',
    ordernumber: '訂單號',
    orderstatus: '訂單狀態',
    tobepaid: '待支付',
    paymentsuccessful: '支付成功',
    cancelorder: '取消訂單',
    paymenttime: '付款時間',
    orderamount: '訂單金額',
    paymenttype: '支付類型',
    wechat: '微信',
    alipay: '支付寶',
    contractdownload: '契約下載',
    organizeinformation: '組織資訊',
    fullorganizationname: '組織全稱',
    organizespecificaddress: '組織具體地址',
    zipcode: '郵遞區號',
    emailaddress: '電子郵箱',
    contactname: '連絡人姓名',
    mobilenumber: '手機號碼',
    fax: '傳真',
    additionalorders: '增購訂單',
    additionalpurchasetype: '增購類型',
    increaseaccountnumber: '新增賬戶數',
    companyname: '機構名稱',
    contractpreview: '契約預覽',
    continuelongtime: '續費時長',
    durationofuse: '使用時長',
    expandedquantity: '擴充數量',
    numberofpackages: '套餐數量',
    expansionspace: '擴充空間',
    paymentamount: '付款金額',
    companypackageendtime: '機構套餐結束時間',
    paymentamountcalculate: '付款金額=（套餐結束時間-當天時間）*契約帳戶單價',
    methodofpayment: '支付方式',
    paynow: '立即支付',
    payTip1: '系統在收到款項支付後自動生成續費訂單並完成續費服務',
    payTip2: '如果您已完成付款而未成功續費，請撥打免費諮詢熱線',
    teamfacecashier: '收銀臺',
    scanpayment: '掃壹掃付款（元）',
    turnonphonewechat: '打開手機微信',
    scancompletepayment: '掃壹掃完成支付',
    pay: '支付',
    completepayment: '完成支付',
    youcanchoose: '您可以選擇',
    gototheadminhomepagetoviewconsumption: '到管理首頁查看消費情況',
    paymentfailed: '支付失敗',
    suggestyouselect: '建議您選擇',
    reorderpayment: '重新下單支付',
    renewal: '續費',
    expansionseat: '擴充坐席',
    expandeddataaggregate: '擴充數據總量',
    expandeddata: '擴充數據',
    totaldatacharge: '充數據總量',
    expandedseats: '擴充席位',
    upgradedversion: '升級版本',
    order_amount_error: '訂單金額異常',
    company_full_name_error: '組織全稱不能為空',
    company_address_error: '組織具體地址不能為空',
    email_empty: '電子郵箱不能為空',
    email_error: '電子郵箱格式錯誤',
    contact_name_error: '連絡人姓名不能為空',

    modifyEnterpriseName: '修改機構名稱',
    modifyEnterpriseTip:
      '修改當前機構資訊後，涉及的相關地方將全部被更新替換，建議不要頻繁的修改機構資訊，以免機構成員不能正常識別。',
    enterpriseAdress: '機構地址',
    modifyEnterpriseAdress: '修改機構地址',
    modifyEnterpriseTip2: '不同部門可以使用不同的機構地址。',
    addAddress: '添加機構地址',
    continueaddAddress: '繼續添加機構地址',
    editentErpriseLogo: '修改機構LOGO',
    logoTip: '建議上傳PNG透明無底色反白logo，240*70大小的PNG圖片；大小不超過1M；',
    updateLogo: '上傳logo',
    modifylocalDomainAddress: '修改當地語系化的功能變數名稱地址',
    domainAddressTip:
      '修改本地化的功能變數名稱地址，用於與認證平臺建立連結，保障能正常使用本系統。',
    domainAddressTip2: '請輸入花生殼功能變數名稱或公網IP（包含埠且必填）',
    modifylocalIMaddress: '本地IM地址',
    imAddressTip: '可修改IM地址，請輸入正確的IP地址，用於即時通的使用',
    appBannerSet: '移動端Banner設定',
    updateTip: '建議上傳JPG格式圖片，1035*420大小的PNG圖片、最多上傳5張；每張大小不超過1M；',
    updateBanner: '上傳Banner',
    languageSelect: '語言選擇',
    setLanguageType: '設定平台的語言類型',
    chinese: '簡體中文',
    traditional: '繁體中文',
    english: '英語',
    transferEnterprise: '平臺負責人',
    transferEnterpriseTip:
      '如果妳不想再管理當前平台機構，妳可以選擇轉讓給機構中的其他成員，轉讓之後妳將無法在管理當前平台機構，並且該操作無法撤銷。',
    selectOwner: '選擇負責人',
    loginPwd: '登入密碼',
    inputCurrentPwd: '輸入當前帳號密碼',
    enterpriseName: '機構名稱',
    enterpriseName_empty: '機構名稱不能為空',
    domain_empty: '功能變數名稱地址不能為空',
    adress_error: '地址格式不正確',
    maxImages5: '最多上傳5張圖片',
    image_empty: '請上傳圖片',
    imageSize: '每張圖片大小不超過1M',
    owner_empty: '平台負責人不能為空',
    imageFormat: '請上傳PNG或JPG圖片',
    imageLimit: '圖片超過上傳限制',
    inputAddress: '請輸入機構地址',
    pleaseSelectDepartment: '請選擇部門',
    departmentalDuplication: '部門重複，請重新選擇',
    billManage: '帳單管理',
    SMSManage: '簡訊管理',
    addWorkflow: '新建工作流',
    userMember: '使用人員',
    workflowName: '工作流名稱',
    addMember: '添加成員',
    workflowDesc: '工作流描述',
    inputContent1000: '請輸入內容，限制1000個',
    inputWorkflowName25: '請輸入工作流名稱，限制25個字',
    workflowNameNotEmpty: '工作流名稱不能為空',
    sureDelWorkflow: '確定要刪除該工作流嗎?',
    addContion: '添加條件',
    resetWorkflowDelInfo: '重置後流程會恢復初始化樣式，已設定好的工作流會被還原。你確定要重置嗎？',
    binding: '綁定',
    accountBinding: '帳戶綁定',
    sendManage: '發送管理',
    signtrue: '簽名',
    accountBindingMsg1:
      '使用簡訊前，先在對應的短信平臺註冊帳戶，註冊成功後將AppKey和Master Secret填寫到系統中進行綁定',
    accountBindingMsg2: '短信平臺',
    accountBindingMsg3: '發送短信狀態回檔',
    accountBindingMsg4:
      '用於審批失敗時獲取失敗原因，在極光系統的【簡訊設定】中將URL複製到“下行消息發送狀態回檔設定”中',
    accountBindingMsg5: '模版稽核狀態回檔',
    accountBindingMsg6:
      '用於審批失敗時獲取失敗原因，在極光系統的【簡訊設定】中將URL複製到“模版稽核結果回檔”中',
    accountBindingMsg7: '名稽核狀態回檔',
    accountBindingMsg8:
      '用於審批失敗時獲取失敗原因，在極光系統的【簡訊設定】中將URL複製到“簽名稽核結果回檔”中',
    accountBindingMsg9: '在極光系統中的【應用設定】-【應用資訊】中可查找到',
    AppKeyNotEmpty: 'AppKey不能為空',
    MasterNotEmpty: 'Master Secret不能為空',
    sendContent: '發送內容',
    downAll: '下載全部',
    failReason: '失敗原因',
    sending: '發送中',
    sendSuccess: '發送成功',
    sendFail: '發送失敗',
    sendStatus: '發送狀態',
    sendCount: '發送數量',
    receiveMunber: '接收號碼',
    sendTiem: '發送時間',
    allInfo: '全部資訊',
    signtrueName: '簽名名稱',
    signtrueType: '簽名類型',
    documentaryEvidence: '證明檔案',
    documentaryEvidenceInfo: '檔案支持PNG、JPG、JPEG格式，且大小不超過2M',
    applicationNotes: '申請說明',
    name: '名稱',
    nameInfo: '長度顯示2-8個字元，無需添加【】',
    uploadFile: '上傳文件',
    signtrueTypeInfo1: '機構名稱全稱或簡稱',
    signtrueTypeInfo2: '需提供營業執照',
    signtrueTypeInfo3: '工信部備案的網站全稱或簡稱',
    signtrueTypeInfo4: '需提供主辦單位的營業執照',
    signtrueTypeInfo5: 'APP應用全稱或簡稱',
    signtrueTypeInfo6: '需提供任壹應用商店的下載連結及開發者的營業執照',
    signtrueTypeInfo7: '公眾號或小程式名稱的全稱或簡稱',
    signtrueTypeInfo8: '需提供公眾號（小程式）主體營業執照',
    signtrueTypeInfo9: '電商平臺店鋪全稱或簡稱',
    signtrueTypeInfo10: '需提供經營者營業執照',
    signtrueTypeInfo11: '商標名稱全稱或簡稱',
    signtrueTypeInfo12: '需提供商標註冊證書',
    signtrueTypeInfo13: '其他',
    signtrueTypeInfo14: '需提所有者供營業執照',
    signtrueTypeInfo15: '請簡略描述您的業務場景，不超過100字',
    nameMustfill: '名稱必填',
    documentaryFlieNotEmpty: '證明檔案不能為空',
    applicationNotesMustfill: '申請說明必填',
    sureDelFigntrue: '你確認要刪除該簽名嗎?',
    determineDelete: '該簽名下存在簡訊模版，請確認簽名已無模版使用',
    picMax2M: '圖片不得超過2MB',
    onlineApproval: '線上審批，高效直達',
    approvalType: '審批類型',
    dataQuery: '資料查詢',
    startPer: '發起人',
    query: '查詢',
    ModifyCurrentApprover: '修改當前審批人',
    currentApproverModufy: '將當前審批人員修改為指定人員',
    projectInfo: '視覺化的組織工具，可以幫助您更快，更準確地管理和監督項目的開發',

    customLogin: '自定義登入設定',
    customLoginTip:
      '用戶可以根據自己的個性化需求，定義平台登入管道、平台logo、機構風采、機構地址等。',
    enableCustomLogin: '啟用自定義登錄設計',
    loginAddress: '啟用自定義登入設計',
    loginAddress1: '請輸入（至少6比特，需字母開頭）',
    corporateShowcase: '平台logo圖',
    imagesTip: '支持jpg、gif、png格式，不超過5M圖片',
    leftImage: '登入側邊主圖',
    uploadPicture: '上傳圖片',
    reset: '重置',
    pictureSuggestedSize: '圖片建議尺寸',
    pageBackground: '頁面背景',
    backgroundColor: '背景顏色',
    backgroundPicture: '背景圖片',
    fontColor: '字體顏色',
    loginMethod: '登入管道',
    automaticLoginOptions: '自動登錄選項',
    check: '勾選',
    donotcheck: '不勾選',
    hide: '隱藏',
    display: '顯示',
    registrationEntry: '註冊入口',
    visitWebsite: '訪問官網',
    websiteTip: '可輸入機構官網地址',
    website_empty: '訪問官網不能為空',
    weChatNote:
      '操作方法：將下方鏈接地址設置在公眾號菜單中。( 註：微信需求本地化客戶的地址端口必須用80或443端口，否則微信公眾號不可通過地址訪問系統。)',
    weChatPublicAccess: '微信公眾號訪問',
    weChatPublicAccount: '微信公眾號',
    weChatPublicAccountContent: '通過微信公眾號直接訪問系統自定義模塊',
    weChatPublicAccountName: '微信公眾號名稱',
    pushModule: '推送模塊',
    setTemplateID1: '微信公眾號消息推送設置',
    setTemplateID2:
      '通過微信公眾號設置，系統將支持將消息推送至微信公眾號，不填寫及標識不需要推送消息至微信公眾號。',
    setTemplateID3: '微信公眾號消息模板ID',
    setTemplateID4:
      '進入微信公眾號 後臺 ->功能->添加功能插件處 申請模板消息功能，審批通過後可在列表中獲得模塊ID',
    loginFreeSettings: '免登錄設置',
    loginFreeSettingsNote:
      '進入微信公眾號後臺，將微信公眾號後臺對應內容輸入至系統中，可實現免登錄；',
    nailingLink: '路徑：釘釘開發平臺-->應用開發-->H5微應用-->應用詳情-應用信息下',
    nailingLink2: '路徑：釘釘開發平臺-->應用開發-->登錄',
    nailingLink3: '釘釘開發平臺-->基本信息-->開發信息（舊版）-->企業自用賬號信息',
    autonomousApplication: '釘釘或企業微信-自主應用設置',
    autonomousApplicationTip:
      '設置後本地化客戶可在釘釘或企業微信中進行使用，設置前請在釘釘或企業微信申請上傳自主H5微應用。',
    nailing: '釘釘',
    enterpriseweChat: '企業微信',
    scanLogin: '掃碼登錄配置',
    weChatjsUrl:
      '進入微信公眾號後臺-->右上角頭像-->功能設置-->功能設置-->JS接口安全域名行中點擊設置-->彈窗中下載文件（事項3中有個文件點擊下載）',
    weChatjsFile: 'JS接口安全域名文件',
    weChatjsFile_error: 'JS接口安全域名文件只支持txt文本文件',

    localdomainaddresssetting: '本地域名地址設置',
    solidcolor: '純色',
    publicqrcodereplacement: '公眾號二維碼替換',
    uploadcompanyqrcodesofficialaccount: '上傳機構的公眾號二維碼',
    title: '標題',
    qrcode: '二維碼',
    uploadqrcodepicture: '上傳二維碼圖片',
    publishapplication: '發布應用',
    webaddress: 'WEB地址',
    pcsidebackgroundconfiguration: 'PC端後臺配置',
    receivingserveraddress: '接收服務器地址',
    enterpriseloginaddress_empty: '專屬登錄地址不能為空',
    enterpriseloginaddress_error: '專屬登錄地址只能存在英文與字母',
    bindingnailingconfirm: '確定要重新綁定釘釘嗎？',
    bindingweChatconfirm: '確定要重新綁定企業微信嗎？',
    enterpriseloginaddress_error2: '專屬登錄地址沖突',
    companyNumber: '機構/平台編號',
    enterprisedisplaychart: '背景展示圖',
    usercertificate: '使用證書',
    certificate: '授權證書',
    cloud: '雲服務',
    local: '本地',
    upgradeTip: '使用該功能需要升級更高版本',
    upgradeAlert: '升級提醒',
    upgradeTip2: '尊敬的用戶，使用該功能需要升級更高版本',
    enquiryHotline: '咨詢熱線',
    scanningconsulting: '掃碼咨詢升級服務',
    openconnection: '打開連接',
    submitupgraderequestonli: '在線提交升級需求',
    pgradeNow: '立即升級',
    versionUpgrade: '版本升級',
    selectversion: '選擇版本',
    fit: '適合',
    customEdition: '定制版',
    customExclusiveVersion: '根據需求定制專屬版本',
    payasyouwant: '按需付費',
    onDemand: '按需定制',
    applynow: '立即申請',
    renewalOrder: '續費訂單',
    renewalPeriod: '續費年限',
    upgradedVersionOnly: '不續時間，僅升級版本',
    singleTotal: '單總計',
    accounerror: '賬戶數低於版本最低人數限制，請先增加賬戶數再進行版本升級',
    upgradeto: '升級為'
  },
  // 成員管理
  membership_management: {
    department: '部門',
    seachall: '搜索',
    disabledEmployee: '已停用的員工',
    jobManage: '職務管理',
    personCharge: '負責人',
    searchResult: '的搜索結果',
    addStaff: '添加員工',
    updateStaff: '上傳員工',
    adjustDepartment: '調整部門',
    changeRole: '更換角色',
    addRoles: '追加角色',
    resetPwd: '重置密碼',
    activationReminder: '激活提醒',
    addDepartment: '添加部門',
    departmentName: '部門名稱',
    superiorDepartment: '上級部門',
    editDepartment: '編輯部門',
    departmentTip: '請確保刪除的部門已無成員，若存在成員將刪除失敗。',
    confirmDeletion: '確定要刪除“',
    departmentTip2: '”部門嗎？',
    departmentTip3: '註意：審批流程和自定義設置可能存在調用，刪除前請先調整設置。',
    pwdType: '密碼類型',
    SMSpwd: '短信密碼',
    manualInput: '手動輸入',
    initializePwd: '初始化密碼',
    subordinateDepartment: '所屬部門',
    mainDepartment: '主部門',
    editMember: '編輯成員',
    owner: '平台負責人',
    setPersonCharge: '設置負責人',
    departmentStaff: '該部門員工',
    common: '共',
    activationTip: '提示：此項操作僅對未激活賬號發送激活提醒短信。',
    confirmThe: '確定對選中的',
    activationTip2: '個員工賬號激活提醒嗎？',
    stopUsingTip: '提示：停用後，該賬號將無法登錄當前平台機構',
    stopUsingTip2: '個員工賬號停用嗎？',
    deleteTip: '你確定刪除選中的賬號嗎？',
    enableTip: '提示：啟用後，成員將可以繼續登錄系統。',
    enableTip2: '個員工啟用嗎？',
    postManage: '職務管理',
    addDuties: '添加職務',
    deleteTip2: '提示：刪除後，職務將無法恢復，請謹慎操作。',
    deleteTip3: '你確定要刪除此職務嗎？',
    batchImportEmployee: '批量導入員工',
    selectFile: '選擇文件',
    uploadStaff: '上傳員工',
    clickDownload: '點擊下載',
    employeeTemplate: '員工通訊錄導入模版',
    templateTip: '上傳填寫正確的員工通訊錄導入模版',
    matters: '註意事項',
    matterTip:
      '填寫信息時註意不要修改表頭名稱,標為必填項的都需要填寫。允許導入的文檔格式為:xls、xlsx；壹次導入條數不超過1000條且文件大小不能超過4M。如果導入的資料過多,時間會較長,請耐心等待。',
    pwd: '密碼',
    department__empty: '部門名稱不能為空',
    departmentLength: '部門名稱不能超過25個字符',
    name_empty: '姓名不能為空',
    role_empty: '角色不能為空',
    mianDepartment_empty: '主部門不能為空',
    selectdepartment: '請選擇部門',
    noInactiveMembers: '沒有選中未激活的成員',
    noOperateOwner: '不能操作平台負責人',
    disabledEmployee2: '已停用員工',
    post_empty: '職位不能為空',
    uploadFormat_error: '上傳格式錯誤',
    uploadResults: '上傳結果',
    addChildDeppartment: '添加子部門',
    editDeppartment: '編輯部門',
    deleteDeppartment: '刪除部門',
    organizationalstructure: '組織架構',
    addressbookisolation: '通訊錄隔離',
    character: '角色',
    user: '用戶',
    member: '成員',
    activation: '激活',
    unbindenterprisewechat: '解綁企業微信',
    synchronousorganizationarchitecture: '同步組織架構',
    departmentsettings: '部門設置',
    unstaple: '解綁釘釘',
    bindcomparisontable: '綁定對照表',
    entrydate: '入職日期',
    weChataccount: '企業微信賬戶',
    accountcorrespondingtable: '企業微信賬戶和本平台賬戶對應表',
    teamfaceaccount: '本平台賬戶',
    correspondingtableTip:
      '企業微信未對應成員將添加賬戶至本平台，對應成員將企業微信成員綁定本平台原賬戶。',
    unbindenterpriseweChatTip: '確定要解除與釘釘的綁定嗎',
    unbindenterpriseweChatTip2:
      '解綁後，組織架構、成員、角色將允許維護。如需重新綁定，請至【系統管理】中設置重新綁定；',
    personnelOptionalConfig: '人員可選配置',
    personnelOptionalConfigRemark:
      '設置員工是否可配置接單開關，員工開啟接單開關後才能被選中。',
    showReceiveOrderSwitch: '是否顯示接單開關',
    showReceiveOrderSwitchTip: '選擇“是”則在移動端我的頁面顯示接單開關',
    forceReceiveOrderSwitch: '是否強制接單開關開啟',
    forceReceiveOrderSwitchTip: '選擇“是”則接單開關強制開啟，不可關閉',
    departmentOptionalConfig: '部門可選配置',
    addressbookisolationremark:
      '設置後將對隔離的部門在通訊錄中進行隱藏/限制，自定義模塊和固定模塊都對應在人員組件和部門組件中受到該設置限制。',
    quarantinedepartment: '隔離部門',
    quarantinedepartmentRaio1: '是否對上面選中的部門在通訊錄中隱藏',
    quarantinedepartmentRaio2: '是否對上面選中的部門在通訊錄中限制查看詳細信息',
    quarantinedepartmentsettings: '隔離部門設置',
    addmembersdepartmentsroles: '添加成員、部門、角色',
    quarantinedepartmentRaio3: '不隱藏',
    quarantinedepartmentRaio4: '對部門外隱藏，但部門內和上級部門的負責人需顯示',
    quarantinedepartmentRaio5: '對部門外隱藏',
    quarantinedepartmentRaio6: '對部門外隱藏，且僅可查看自己',
    quarantinedepartmentRaio7: '不限制',
    quarantinedepartmentRaio8: '僅可查看本部門內成員',
    quarantinedepartmentRaio9: '僅可查看自己',
    departmentcannotbeempty: '部門不能為空',
    language: '語言',
    memberexpo: '成員匯出',
    // 20210120
    leaderDisplay: '負責人顯示',
    avatardisplay: '頭像顯示',
    addedSubordinateOrganization: '新增下級組織',
    editOrganizationalInformation: '編輯組織信息',
    deletecurrentorganization: '刪除當前組織',
    additionalPersonnel: '新增人員',
    relatedStaffDetails: '關聯員工詳情',
    selectatleastonefieldtomatch: '至少選擇壹個匹配對應字段',
    selectamoduleinfor: '選擇壹個模塊展示個人資料信息',
    selectmodule: '選擇模塊',
    selectfieldtomat: '選擇匹配字段',
    relatedStaffTip: '確定要清空關聯員工詳情信息嗎？',
    // 20210526
    userNameLeastOneItem: '手機號碼或電子郵箱或工號至少填一項',
    userNameLeastOneItem2: '手機號碼或電子郵箱至少填一項',
    emid_error: '工號格式錯誤',
    // 20220412
    activeemployee: '在職員工',
    inactive: '未啟動的',
    loginprohibited: '禁止登入',
    deactivated: '已停用',
    loginprohibitedTip:
      '勾選則代表當前人員為虛擬帳戶，不登入系統，但是會參與考勤機對接、薪酬計算等業務操作',
    batchSelectTip: '您同時勾選了“啓用”和“停用”的人員，無法進行批量操作'
  },
  // 角色管理
  role_management: {
    addGroup: '新建分組',
    editGroup: '編輯分組',
    deleteGroup: '刪除分組',
    addRole: '新增角色',
    deleteRole: '刪除角色',
    editRole: '修改角色',
    editRole2: '編輯角色',
    copyRole: '復制角色',
    roleTip:
      '如需更換平台負責人，請到【系統管理】頁面，點擊【變更負責人】來更換所有者，設置完成後信息自動同步。',
    managemember: '管理成員',
    apply: '應用',
    module: '模塊',
    dataJurisdiction: '數據權限',
    funJurisdiction: '功能權限',
    allSelect: '全選',
    oneselfData: '僅查看本人數據',
    departmentData: '查看本部門數據',
    companyData: '查看全機構數據',
    groupName: '分組名稱',
    groupDeleteTip: '提示：刪除後，該分組將無法恢復，請謹慎操作。',
    groupDeleteTip2: '您確定刪除分組？',
    roleName: '角色名',
    roleGroup: '角色組',
    roleGroup2: '角色分組',
    describe: '描述',
    roleDeleteTip: '刪除後，該角色將無法恢復，請謹慎操作。',
    roleDeleteTip2: '確定要刪除該角色嗎？',
    roleDeleteTip3: '註意：審批流程和自定義設置可能存在調用，刪除前請先調整設置。',
    group_empty: '角色組名不能為空！',
    addGroupTip: '請先新建分組',
    role_empty: '角色名不能為空！',
    updateTip: '內容有更新，是否需要保存？',
    charactersettings: '角色設置',
    rolemember: '角色成員',
    businesspermissions: '業務權限',
    backgroundadministrationauthority: '後臺管理權限',
    menuname: '菜單名稱',
    permissions: '權限'
  },
  // 安全管理
  safe_management: {
    securitysetting: '安全設置',
    pwdPolicy: '密碼策略',
    sessionSet: '會話設置',
    dataBackup: '數據備份',
    IPrestriction: 'IP限制',
    logManage: '日誌管理',
    pwdvalidity: '用戶密碼有效期',
    pwdMinLength: '密碼最小長度',
    pwdComplexity: '密碼復雜性要求',
    pwdError: '密碼輸入錯誤',
    enableSMSauthentication: '次後啟用手機短信驗證',
    lockAccounts: '次後鎖定帳戶15分鐘',
    resetPwd: '全員重置密碼',
    resetMsg:
      '勾選保存後讓機構所有成員立即從當前的登錄設備中退出登錄，重新登錄成功後強制修改密碼才可使用。',
    saveSet: '保存設置',
    automaticLogout: '長時間未操作後自動登出',
    automaticBackup: '本地自動備份',
    backupMsg1: '可以根據自己的數據安全需要，進行本地數據自動備份',
    every: '每',
    backupMsg2: '天系統在淩晨0點自動備份壹次，且僅保留最新的5個備份文件。',
    manualBackup: '手動觸發備份',
    backupName: '備份文件名稱',
    dataReduction: '數據還原',
    reductionMsg: '若企業數據需要還原到以前的內容，可在此進行操作，請勿隨意操作數據還原。',
    reduction: '還原',
    confirmReduction: '確認還原',
    reductionMsg2: '手動上傳數據進行還原',
    addAttachment: '添加附件',
    dataMigration: '雲端數據遷移',
    migrationMsg1: '將雲端備份的文件在此地進行遷移，見雲端的系統遷移至本地。',
    updateFile: '上傳數據文件',
    confirmCoverage: '確認覆蓋',
    cloudBackup: '雲端備份',
    cloudBackupMsg:
      '可以根據平台機構的數據安全需要，進行雲端數據備份。若需要將雲端數據遷移至本地服務器，請下載，下載後在新服務器中重新註冊，註冊時用雲端註冊的機構名稱和手機號碼，然後進入到【系統設置-系統管理】的“數據還原”中上傳備份文件進行還原',
    reductionTip1: '確定要還原嗎？',
    reductionTip2: '註意：還原後系統將按還原文件執行，請勿隨意操作。',
    reductionTip3: '真的要還原嗎？',
    reductionTip4: '請再次確認，確認後將執行還原。',
    backupSuccess: '您的備份已經成功，請到【安全管理】--【數據備份】中獲取',
    ipLimitTip: 'IP設置默認針對全員，白名單賬號不受登錄限制：',
    whiteList: '白名單',
    ipLimitTip2: '限制機構全員僅在以下IP登錄：',
    addIP: '添加IP',
    addIPSegment: '添加IP段',
    loginIP: '登錄IP',
    addPeople: '添加人',
    loginTime: '登錄時間',
    addLoginIP: '添加登錄IP',
    ipTip1: '為了保證平台信息更加安全',
    ipTip2:
      '為了保證平台信息更加安全，平台負責人可以設置登錄IP限制規則。設置後，只能在限制的IP下才可以登錄。',
    ipTip3: '如',
    unlimited: '無限制',
    ipLimit1: '包含字母和數字字符',
    ipLimit2: '包含字母、數字和特殊字符',
    ipLimit3: '包含數字和大小寫字母',
    ipLimit4: '包含數字、大小寫字母和特殊字符',
    AddressDuplication: 'ip地址重復',
    ipFormatError: 'ip格式錯誤',
    ip_empty: '設置ip不能為空',
    backupTip:
      '已經開始備份，因備份時間過長，您可以先去完成其他工作，等備份完成後會將備份文件顯示出來。',
    backupDay_empty: '請輸入備份天數',
    backupDayLength: '請輸入1~100的整數',
    oneYear: '壹年',
    operationLog: '操作日誌',
    loginLog: '登錄日誌',
    operator: '操作人',
    operationTime: '操作時間',
    operationContent: '操作內容',
    remark: '備註',
    createtime: '創建時間',
    ipstartingaddress: 'IP開始地址',
    ipendaddress: 'IP結束地址',
    ipstartingaddresscannotbenull: 'IP開始地址不能為空',
    incorrectipstartaddressformat: 'IP開始地址格式錯誤',
    incorrectipaddressformat: 'IP地址格式錯誤',
    useractionlog: '用戶操作日誌',
    backendoroperationslog: '後臺管理員操作日誌',
    menu: '菜單',
    behavior: '行為',
    username: '用戶名',
    androidclient: 'Android客戶端',
    iosclient: 'IOS客戶端',
    windowsclient: 'Windows客戶端',
    macclient: 'Mac客戶端',
    ipaddress: 'IP地址',
    accountpasswordlogin: '賬號密碼登錄',
    mobilephonescancodetologin: '手機掃碼登錄',
    ADdomainLogin: 'AD域登錄',
    loginstatus: '登錄狀態',
    loginsuccessful: '登錄成功',
    loginfailed: '登錄失敗',
    ipendaddressformat: 'IP結束地址格式錯誤',
    devicetype: '設備類型',
    basic_workbench: '基礎模塊-門戶管理',
    basic_project: '基礎模塊-協作',
    basic_email: '基礎模塊-郵件',
    basic_approval: '基礎模塊-審批',
    basic_filelibrary: '基礎模塊-文件庫',
    basic_repository: '基礎模塊-知識庫',
    basic_attendance: '基礎模塊-考勤',
    basic_salary: '基礎模塊-薪酬',
    // 20210601
    enableSMSauthentication2: '次後啟用手機短信/郵箱驗證'
  },
  // 接口集成
  interface_integration: {
    interface: '接口',
    serviceInterface: '服務接口',
    address: '地址',
    interfaceSpecification: '接口說明',
    secretKey: '密鑰',
    reset: '重 置',
    pwd: '密碼',
    resetTip:
      '註：Authtoken和API密鑰是重要的接口調用憑證，請註意保密！如不慎泄密，請立即重置，重置後將新API密鑰發送給接口調用方修改憑證！',
    customInterface: '自定義接口',
    thirdPartyInterface: '第三方接口',
    pluginDownload: '插件下載',
    downloadPlugin: '下載插件',
    useResumeParsingInterface: '使用簡歷解析接口，請先',
    installPlugIns: '安裝插件',
    setRule: '設置規則',
    receiveResumeModule: '接收簡歷模塊',
    recognitionField: '識別字段',
    moduleField: '模塊字段',
    valueMapping: '的值映射為',
    value: '的值',
    tip1: '壹鍵導入各大招聘網站的被動求職者，省去壹系列繁瑣的操作。',
    clickHere: '【點擊這裏】',
    downloadPluginTip: '下載插件，按照步驟手動安裝。',
    lunboTip1: '① 解壓縮文件: 下載文件並解壓',
    lunboTip2: '② 復制鏈接: 使用Chrome瀏覽器, 復制chrome://extensions並粘貼到地址欄, 按回車鍵',
    lunboTip3:
      '③ 拖拽文件夾: 拖拽解壓後的文件夾至瀏覽器, 瀏覽器右上角將出現圖標, 請勿將文件夾刪除或改變路徑',
    receivingResume: '接收簡歷模塊不能為空',
    fieldSet: '字段設置不能為空',
    dataBase: '數據庫',
    pleaseConnectToDatabase: '請先連接數據庫',
    successfulConnection: '連接成功',
    unconnected: '未連接',
    customModule: '自定義模塊',
    databaseForm: '數據庫表單',
    modifier: '修改人',
    modificationTime: '修改時間',
    databaseConnectionSettings: '數據庫連接設置',
    serverAddress: '服務器地址',
    portNumber: '端口號',
    databaseBame: '數據庫名稱',
    userName: '用戶名',
    test: '測試',
    connectionFailed: '連接失敗',
    saveTip: '連接成功才可以保存',
    interfaceType: '接口類型',
    changeTime: '變更時間',
    ruleCondition: '規則條件',
    fieldCorrespondence: '字段對應關系',
    customModuleFields: '自定義模塊字段',
    databaseFormFields: '數據庫表單字段',
    beCareful: '請註意：第壹行為唯壹約束ID，將作為數據變更後判斷的條件。',
    dynamicValue: '動態值',
    fixedValue: '固定值',
    deleteTip: '確定要刪除該數據嗎？',
    readData: '讀取數據',
    addData: '新增數據',
    editData: '編輯數據',
    deleteData: '刪除數據',
    queryData: '查詢數據',
    viewDetails: '查看詳情',
    serverAddress_empty: '服務器地址不能為空',
    portNumber_empty: '端口號不能為空',
    portNumber_error: '端口號格式錯誤',
    dataBase_empty: '數據庫不能為空',
    dataBaseNmae_empty: '數據庫名稱不能為空',
    userName_empty: '用戶名不能為空',
    databaseForm_empty: '數據庫表單不能為空',
    customModule_empty: '自定義模塊不能為空',
    constraint_empty: '約束不能為空',
    integrate: '設置本系統與第三方平臺系統接口集成',
    platform: '平臺名稱',
    ali: '阿裏雲',
    UFU8: '用友U8',
    kingdee: '金蝶',
    platform_empty: '平臺名稱不能為空',
    method: '請求方式',
    fieldName: '字段名稱',
    fieldID: '字段ID',
    fieldType: '字段類型',
    fieldRequired: '是否必填',
    fieldExplain: '說明',
    explain: '請求示例',
    generateSignature: '生成簽名',
    referenceFile: '引用文件',
    requestEncryption: '請求加密',
    local: '本機',
    publicNetwork: '公網',
    returnInstructions: '返回說明',
    requestFailure: '請求失敗',
    requestSuccess: '請求成功',
    basicmodule: '基礎模塊',
    staff: '員工',
    requestHeader: '請求頭',
    requestHeaderParameters: '請求頭參數',
    requestAddress: '請求地址',
    staffList: '員工列表',
    stafDetail: '員工詳情',
    departmentalList: '部門列表',
    departmentDetail: '部門詳情',
    identityAuthentication: '身份認證',
    autograph: '簽名',
    returnType: '返回的內容的類型；默認',
    option: '選項',
    aliCluster: '阿裏雲集成',
    alitilte: '人工智能插件',
    aliP1: '購買對應接口後，在“雲市場-買家中心-進入管理控制臺” 找到對應接口appCode。',
    aliAddress: '阿裏雲接口購買地址',
    payaccessto: '支付接入',
    openTip1: '開通後，可以使用支付寶支付，使用支付功能請在自定義組件數字或公式屬性中開啟。',
    openTip2: '開通後，可以使用微信支付，使用支付功能請在自定義組件數字或公式屬性中開啟。',
    setnow: '立即設置',
    openalipay: '開通支付寶',
    openwechatpay: '開通微信支付',
    openTip3: '請進入【支付寶】獲取對應信息進行配置',
    openTip4: '請進入【微信後臺】獲取對應信息進行配置',
    operationmode: '操作方式',
    operationmodeTip1: '登錄微信服務號後臺-->微信支付-->產品中心-->AppID賬號管理-->服務號的Appid',
    operationmodeTip2: '登錄微信服務號後臺-->微信支付-->賬戶中心-->個人信息-->登錄賬號',
    operationmodeTip3: '登錄微信服務號後臺-->微信支付-->賬戶中心-->API安全-->API密鑰',
    alipaypay: '支付寶支付',
    wechatpay: '微信支付',
    doyouwanttounbind: '是否要解綁',
    unbindsuccessfull: '解綁成功',
    getSign: '獲取簽名',
    apiPwd: 'API秘鑰',
    sqldocking: '輸入sql-對接系統',
    sqldocking2: '輸入sql-本系統',
    maintableid: '主表ID',
    usedplugin: '已使用插件',
    uninstall: '卸載',
    allplugin: '所有插件',
    downloaded: '已下載',
    ssotip: '可免登陸訪問其它關聯系統',
    ssotip2:
      '通過單點登錄，用戶在系統工作臺中可以實現一鍵登錄到其他系統，不必要再次輸入用戶名/密碼。',
    resumeanalysistip: '使用簡歷解析接口',
    backtoplugin: '返回插件管理',
    systemname: '系統名稱',
    systemaddress: '系統地址',
    systemaddress_empty: '系統地址不能為空',
    authorizedUser: '授權用戶',
    authorizedUser_empty: '授權用戶不能為空',
    accountType: '賬戶類型',
    useTeamfaceaccount: '使用本平台賬戶',
    userentry: '用戶錄入',
    accountparametername: '賬戶參數名',
    accountparametername_empty: '賬戶參數名不能為空',
    passwordparametername: '密碼參數名',
    passwordparametername_empty: '密碼參數名不能為空',
    putitinmyapplist: '放入到我的應用列表',
    displayinportalcolumn: '放入門戶欄目顯示',
    openmode: '打開方式',
    newwindow: '新窗口',
    currentworkspace: '當前工作區',
    otherparameters: '其它參數',
    addparameters: '添加參數',
    parametername: '參數名稱',
    parametervalue: '參數值',
    displayposition: '顯示位置',
    ssoinfo:
      '單點登錄（SSO），用戶登錄本平台後，可免登陸訪問系統中其他關聯的系統應用即不需要再次輸入帳戶和密碼即可訪問其他系統應用，比如CRM、OA、ERP等，減少登錄產生的時間消耗和帳戶密碼過多。',
    charge: '收費',
    pluginintroduce: '插件介紹',
    // 20210526
    dfmasaf: '數據庫表單主子表關聯字段',
    dfmasaf_empty: '數據庫表單主子表關聯字段不能為空',
    timeRepeat: '變更時間不能與修改時間重復',
    miniprogram: '小程序名片',
    miniprogramremark: '讓客戶第一時間了解我們',
    miniprogramnote: '一站式社交名片、產品櫥窗、線索雷達的社會化營銷平臺',
    isenable: '是否啟用',
    bindenterprises: '綁定機構',
    bindmodule: '綁定模塊',
    showCardTip: '選擇或新建一個模塊展示名片訪客信息',
    leastOneItem: '至少配置模塊和一個字段',
    mapIntegration: '地圖集成',
    bindBaiduAK: '綁定百度AK',
    bindBaiduAKInfo:
      '使用考勤定位和自定義組件.地圖組件，都要綁定百度地圖AK，請到百度地圖中申請AK，如果沒有綁定則不能允許地圖定位功能；',
    bindGaoDeAK: '綁定高德AK',
    bindGaoDeClientAK: '客戶端AK',
    bindGaoDeSecurity: '客戶端密鑰',
    bindGaoDeAKInfo:
      '使用考勤定位和自定義組件.地圖組件，都要綁定高德地圖AK，請到高德地圖中申請AK，如果沒有綁定則不能允許地圖定位功能；',
    mapBaidu: '百度地圖',
    mapGaoDe: '高德地圖',
    mapSource: '地圖源'
  },
  // 應用中心
  application_center: {
    recommend: '精品推薦',
    industryCategory: '行業分類',
    myUploads: '我的上傳',
    serviceClassification: '業務分類',
    receiptsDetails: '收款明細',
    appIcon: '應用圖標',
    appName: '應用名稱',
    price: '價格',
    free: '免費',
    pay: '付費',
    uploader: '上傳人',
    updataTime: '上傳時間',
    state: '狀態',
    yobeAudited: '待審核',
    notpass: '未通過',
    havePassed: '已通過',
    operation: '操作',
    details: '詳情',
    auditOpinion: '審核意見',
    msg1: '確定要刪除該應用嗎？',
    msg2: '本操作只會在 “我的上傳” 列表中刪除，不影響該應用在其他模塊的使用。',
    totalSum: '總金額',
    auditAmount: '審核金額',
    arrivalAccount: '到賬金額',
    downNum: '下載次數',
    msg3: '很遺憾您上傳的應用未能通過審核...',
    msg4: '您可以嘗試按照以下（包括但不限於）修改意見來調整您的應用以便重新提交至審核。',
    team: '團隊',
    auditIn: '審核於',

    industry: '行&nbsp;&nbsp;業',
    install: '安裝',
    alreadyInstall: '已安裝',
    onTrial: '試用',
    classify: '分&nbsp;&nbsp;&nbsp;&nbsp;類',
    price2: '價&nbsp;&nbsp;&nbsp;&nbsp;格',
    developer: '開發者',
    installNum: '安裝次數',
    second: '次',
    score: '評分',
    moduleIntroduction: '模塊介紹',
    moduleScreenshots: '模塊截圖',
    sweepingPayment: '掃壹掃付款：',
    wechatpay: '打開手機“微信掃壹掃”掃描二維碼完成支付',
    aliipay: '打開手機支付寶掃描二維碼完成支付',
    paymenCompleted: '完成支付',
    installSuccess: '安裝成功',
    sweepCodePayment: '請先掃碼付款',

    sizeInfo: '10條/頁',
    expandMore: '展開更多',
    star: '星級',
    star_empty: '星級不能為空',
    comment_empty: '評論不能為空',
    send: '發送',
    installation: '應用正在安裝中，請稍後在自定義應用列表中查看',
    cost: '費用',
    customization: '定制',
    // 20220412
    iwantconsult: '我要諮詢',
    scanningcodeconsultcustomerservice: '微信掃碼諮詢專業客服',
    experience: '體驗一下',
    startapplication: '啟動此應用',
    version: '所屬版本',
    customizedscenesystem: '根據用戶自身需求，定制符合業務場景使用的應用系統',
    Customizenow: '立即定制',
    installingapp: '正在安裝應用…',
    contactadministratorinstall: '請聯系系統管理員安裝',
    industrySolutions: '行業方案'
  },
  // 回收站
  recycle_bin: {
    module: '模塊',
    deletePerson: '刪除人',
    deleteTime: '刪除時間',
    reduction: '還原',
    emptyTrash: '清空回收站',
    msg1: '確定還原到刪除之前的數據嗎？',
    msg2: '確定要刪除該數據嗎？',
    msg3: '確定要清空回收站嗎？',
    msg4: '刪除後，數據將不可恢復',
    msg5: '清空後，數據將不可恢復',
    // 20220412
    hardDelete: '硬删除'
  },
  // 自动化任务监控
  task_monitoring: {
    selectForm: '選擇表單',
    selectFormPlaceholder: '請選擇表單',
    customNumber: '自定義編號',
    customNumberPlaceholder: '請輸入自定義編號',
    ruleTitle: '規則名稱',
    ruleTitlePlaceholder: '請輸入規則名稱',
    executeStatus: '執行狀態',
    executeStatusPlaceholder: '請選擇執行狀態',
    executeStatusSucc: '執行成功',
    executeStatusFail: '執行失敗',
    serialNumber: '序號',
    taskID: '任務ID',
    moduleName: '表單名稱',
    ruleTriggers: '觸發事件',
    ruleRemark: '規則描述',
    taskStartTime: '任務時間',
    taskExecutionRecord: '任務執行記錄',
    nameOfTheExecutedOperation: '執行操作名稱',
    operationDetail: '操作詳情',
    operationName: '操作名稱'
  },
  // 個人設置
  personal_setting: {
    basicSetup: '基本設置',
    updatePwd: '修改密碼',
    oldPwd: '原密碼',
    newPwd: '新密碼',
    updateInfo:
      '修改密碼時需要輸入當前密碼，如果妳忘記了當前密碼，可以在登錄界面通過“忘記密碼”功能來重置妳的密碼。',
    modifyPhone: '修改手機號碼',
    currentmobile: '妳當前的手機號碼是',
    updatePhoneMsg: '，修改手機時系統會發送驗證碼到新的手機號碼上，然後輸入驗證碼後完成修改。',
    updatePhoneMsg2:
      '手機號碼不但是個人通訊方式，而且還是系統的登錄賬號，如果不是更換手機建議不要隨意修改手機號碼，避免忘記登錄賬號。',
    newNumber: '輸入新手機號碼',
    phoneCode: '輸入手機驗證碼',
    getcode: '獲取驗證碼',
    exitSession: '退出會話',
    exitMsg:
      '如果妳的手機丟失，為了防止其他人看到妳的信息，可以從這裏退出除了當前瀏覽器之外的所有會話。',
    headSculpture: '設置頭像',
    headSculptureMsg: '可更換您的圖片，圖片將會自動生成三種尺寸，請註意更換後的圖片是否清晰。',
    selectPhotos: '選擇照片上傳',
    photoMsg: '僅支持JPG,GIF,PNG格式上傳且文件小於3M。',
    personal: '個人資料',
    personalMsg: '管理您的個人信息並更新姓名、性別、生日等設置。',
    updatePhotos: '上傳頭像',
    phoneCode_empty: '手機驗證碼不能為空',
    codehasbeensent: '驗證碼已經發送到該手機號碼',
    retrieve: '後重新獲取',
    name_empty: '姓名不能為空',
    pwdDifferent: '新密碼與確認密碼不相同',
    photoError: '請上傳JPG,GIF,PNG格式的圖片',
    filesize: '文件大於3M',
    oldPwd_empty: '原密碼不能為空',
    basicInfo: '基本資料',
    thirdpartydataimprovement: '第三方綁定集成資料完善',
    perfectTip:
      '該設置僅在釘釘或企業微信集成模式且未輸入手機號時顯示，補充手機號和登錄密碼後，綁定釘釘和企業微信用戶可以通過手機號+密碼進行登錄。',
    suretomodify: '當前手機號碼存在於另壹家機構，是否確定修改'
  }
}
